import { Component, effect, forwardRef, input, model } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

import {
  ConstField,
  FormBuilderBase
} from '@shared/components/row-edition-form/form-builder/form-builder.model';

import { wrapValue } from '../row-edition-form.utils';

@Component({
  selector: 'app-const',
  imports: [],
  templateUrl: './const.component.html',
  styles: [
    `
      :host {
        display: flex;
        width: 100%;
      }
    `
  ],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => ConstComponent),
      multi: true
    }
  ]
})
export class ConstComponent implements ControlValueAccessor {
  id = input<FormBuilderBase['id']>();
  value = model.required<ConstField['const']>();
  wrapperProperty = input<string | undefined>(undefined);

  constructor() {
    effect(() => {
      // Set the constant value when the value is loaded
      this.onChange(this.value());
    });
  }

  onChange = (_value: ConstField['const']) => {};
  onTouched = () => {};

  onInput(event: Event) {
    const value = (event.target as HTMLInputElement).value;
    this.onChange(value);
  }

  writeValue(_value: ConstField['const']): void {
    // Since this component is read-only, we don't need to implement this method, it must set the constant value.
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  registerOnChange(fn: any): void {
    this.onChange = (value: ConstField['const']) =>
      fn(wrapValue(value, this.wrapperProperty()));
  }

  registerOnTouched(fn: never): void {
    this.onTouched = fn;
  }
}
